import React from 'react'

const ResponsiveImage = ({ post , className}) => {
    const imageSrcSet = `
    ${post?.uagb_featured_image_src?.medium?.[0]} 300w, 
    ${post?.uagb_featured_image_src?.medium_large?.[0]} 768w, 
    ${post?.uagb_featured_image_src?.large?.[0]} 1024w, 
    ${post?.uagb_featured_image_src?.full?.[0]} 1920w
  `;

    const imageSizes = "(max-width: 480px) 300px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1920px";
    const defaultImage = post?.uagb_featured_image_src?.large?.[0] || '/assets/Image2.png';

    return (
        <img
            srcSet={imageSrcSet}
            sizes={imageSizes}
            src={defaultImage}
            alt={post?.title?.rendered}
            className={className}
        />
    );
};

export default ResponsiveImage